import { useState, useCallback, useEffect } from 'react';
import { getTreatmentById } from 'api/treatments';
import { useParams, useHistory } from 'react-router-dom';
import { formatDate, formatDatetime } from 'helpers/timezone';

import NoAccess from 'pages/no_access';
import CustomerCard from 'components/cards/customer';
import ViewField from 'components/view_field/view_field';
import Note from 'components/note/note';
import DocumentsCard from 'components/cards/documents';

import Loading from 'components/loading/loading';
import Deleted from 'components/deleted/deleted';

import { REFERRAL_STATUSES, TYPES } from 'config/treatment';

const TreatmentItem = () => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);
  const [deletedByData, setDeletedByData] = useState(null);
  const { id } = useParams();
  const history = useHistory();

  const fetchTreatment = useCallback(async () => {
    setLoading(true);

    const treatment = await getTreatmentById(id);

    if (treatment.deletedAt && treatment.deletedBy) {
      setDeletedByData({
        email: treatment.deletedBy.email,
        deletedAt: treatment.deletedAt,
      });
    } else {
      setData(treatment);
    }

    setLoading(false);
  }, [id]);

  useEffect(() => {
    (async () => fetchTreatment())();
  }, [fetchTreatment]);

  if (loading) return <Loading />;
  if (data?.statusCode === 403) return <NoAccess />;
  if (deletedByData) return <Deleted deletedBy={deletedByData} />;

  const typeLabel = TYPES.find((t) => t.value === data.type) || {
    label: data.type,
  };
  const referralStatusLabel = REFERRAL_STATUSES.find(
    (t) => t.value === data.referralStatus,
  );

  return (
    <main className="th-main">
      <section className="th-canvas">
        <header className="th-canvas-header post-header">
          <h2 className="th-canvas-title" data-test-screen-title>
            <span>
              {data.customer
                ? `${data.customer.firstName} ${data.customer.lastName}'s treatment`
                : 'Treatment'}
            </span>
          </h2>
          <section className="view-actions">
            <button
              className="btn-green mr5"
              data-cy="edit"
              onClick={() => history.push(`/treatments/${data.id}/edit`)}
            >
              <span>Edit</span>
            </button>
          </section>
        </header>
        <div className="w-100 flex flex-column items-start justify-between">
          <CustomerCard data={data.customer} />
          <ViewField
            label="Doctor"
            value={[
              data.doctor?.lastName?.toUpperCase(),
              data.doctor?.firstName,
            ]
              .filter(Boolean)
              .join(' ')}
          />
          <ViewField label="Treatment type" value={typeLabel.label} />
          <ViewField
            label="Treating organization"
            value={data.treatingOrg?.name}
          />
          <ViewField
            label="Referral status"
            value={referralStatusLabel.label}
          />
          <ViewField
            label="Referral date"
            value={formatDate(data.referredAt)}
          />
          <div className="w-100">
            <span className="apps-grid-title">Created at</span>
            <p className="f7 pa0 ma0 midgrey-d1 nudge-bottom--2">
              {formatDatetime(data.createdAt)}
            </p>
          </div>
          <DocumentsCard data={data.documents} />
          <Note label="Machine Settings" data={data.machineSettings} />
          <Note label="Notes" data={data.notes} />
        </div>
      </section>
    </main>
  );
};

export default TreatmentItem;
